import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Festegrunn from './Festegrunn.jsx'
import FestegrunnIcon from '../../../images/Festegrunn.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class FestegrunnList extends Component {
    state = {
        festegrunner: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null
    }

    getFestegrunner = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/festegrunn`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                festegrunner: [...this.state.festegrunner, ...data.festegrunner],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
      }


    toggleFestegrunner = () => {
        if (this.props.antall == 0) return

        if (this.state.festegrunner.length == 0) {
            this.getFestegrunner()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallFestegrunner = this.state.continuationToken ? `${this.state.festegrunner.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleFestegrunner}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={FestegrunnIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('festegrunner')} ({antallFestegrunner})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.festegrunner.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.festegrunner.map((f, index) => {return (<Festegrunn key={f.matrikkelenhetId} festegrunn={f} antall={this.props.antall} isLast={index==this.state.festegrunner.length-1} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getFestegrunner}>
                                <span>{t('hent.festegrunner')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(FestegrunnList)